import React from 'react'
import './Map.css'

const Map = () => {
  return (
    <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2830.278017942957!2d20.452547415790324!3d44.81590047909859!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a654d50527e81%3A0xd82f5ddd362241cf!2sMar%C5%A1ala%20Birjuzova%2045%2C%20Beograd!5e0!3m2!1sen!2srs!4v1623858005732!5m2!1sen!2srs" >
    </iframe>
  )
}

export default Map